import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";

import ClearIcon from "@mui/icons-material/Clear";

import { message } from "antd";

import LoaderSpin from "../../Commons/LoaderSpin";

import { AutoCompleteSelectClient } from "../../Commons/AutoComplete";

import TextStyles from "../../../../Constants/TextStyles";

import { Modal } from "react-bootstrap";
import { updateProjectDetailPC } from "../../../../store/service/proposalAndContractService";
import SwitchButton from "../../Commons/SwitchButton";
import Colors from "../../../../Constants/Colors";
import SelectCurrency from "../../Commons/SelectCurrency";
import moment from "moment";
import CustomDatePickerOne from "../../Commons/DatePickers/CustomDatePickerOne";
import { pcActions } from "../../../../store/storage/proposalAndContractSlice";

const PCEditProjectInfo = ({ selectedData, show, handleClose }) => {
  const dispatch = useDispatch();
  const clientOptionData = useSelector(
    (state) => state.clients.clientOptionData
  );
  const isLoading = useSelector((state) => state.proposalAndContract.isLoading);

  const [selectEndDate, setSelectEndDate] = useState(
    selectedData && selectedData.project_end_date ? false : true
  );

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      project_name: selectedData && selectedData.project_name,
      client: selectedData && {
        _id: selectedData.client_id._id,
        label: selectedData.client_id.company_name,
      },
      currency: selectedData && selectedData.currency,
      project_start_date:
        selectedData &&
        selectedData.project_start_date &&
        moment(selectedData.project_start_date).toDate(),
      project_end_date:
        selectedData &&
        selectedData.project_end_date &&
        moment(selectedData.project_end_date).toDate(),
    },
  });

  const [endDateErrorMessage, setEndDateErrorMessage] = useState(null);
  const startDate = watch("project_start_date");
  const endDate = watch("project_end_date");

  const validateEndDate = () => {
    const eDate = endDate && moment(endDate);
    const sDate = moment(startDate);
    if (eDate && eDate.isBefore(sDate, "day")) {
      setEndDateErrorMessage(
        `End date should be greater than ${moment(startDate)
          .subtract(1, "d")
          .format("DD MMM YYYY")}.`
      );
      return false;
    } else {
      setEndDateErrorMessage(null);
      return true;
    }
  };

  useEffect(() => {
    validateEndDate();
  }, [startDate, endDate]);

  useEffect(() => {
    setValue(
      "project_end_date",
      selectedData &&
        selectedData.project_end_date &&
        moment(selectedData.project_end_date).toDate()
    );
  }, [selectEndDate]);

  const formsubmit = (data) => {
    const Obj = {
      pc_id: selectedData && selectedData._id,
      client_id: data.client && data.client._id,
      project_name: data.project_name,
      currency: data.currency ? data.currency : selectedData.currency,
      project_start_date: moment(data.project_start_date).toDate(),
      project_end_date:
        selectEndDate || data.project_end_date === undefined
          ? null
          : data.project_end_date && moment(data.project_end_date).toDate(),
    };
    dispatch(updateProjectDetailPC(Obj)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        dispatch(
          pcActions.selectedClientContactAction(
            data.payload.data.client_id.contacts
          )
        );
        handleClose();
        message.success(`${data.payload.message}`);
      } else {
        message.error(`${data.error.message}!`);
      }
    });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      contentClassName="ToMakeModalBorderRudius12px"
      scrollable
    >
      <form
        onSubmit={handleSubmit(formsubmit)}
        style={{ height: "100%" }}
        className="modal-content"
      >
        <Modal.Header
          className="modal-header d-flex justify-content-between"
        >
          <TextStyles.FontSize20px>Project Details</TextStyles.FontSize20px>
          <ClearIcon
            sx={{
              color: Colors.font2,
              cursor: "pointer",
              opacity: 0.7,
              "&:hover": {
                opacity: 1,
              },
            }}
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Body className="modal-body">
          <TextStyles.FontSize14px className="mb-3">
            <label htmlFor="project_name" className="mb-2">
              Project Name
            </label>

            <TextStyles.InputRectangle
              className="mb-0"
              name="project_name"
              id="project_name"
              invalid={errors.project_name}
              type="text"
              placeholder="Project name"
              {...register("project_name", {
                required: "Project name is required.",
                validate: (value) => {
                  let trimedLength = value.trim().length;
                  if (trimedLength === 0) {
                    return "Project name cannot be just empty spaces";
                  }
                  if (trimedLength < 3) {
                    return "Project name must be at least 3 characters";
                  }
                  if (trimedLength > 40) {
                    return "Project name must be at most 40 characters";
                  }
                  return true;
                },
              })}
            />
            {errors.project_name && (
              <TextStyles.InValidFeedback>
                {errors.project_name.message}
              </TextStyles.InValidFeedback>
            )}
          </TextStyles.FontSize14px>
          <TextStyles.FontSize14px className="mb-3">
            <label htmlFor="client" className="mb-2">
              Client
            </label>
            <Controller
              control={control}
              name="client"
              rules={{
                required: {
                  value: true,
                  message: "Client is required.",
                },
              }}
              render={({ field: { onChange, value } }) => (
                <AutoCompleteSelectClient
                  placeholder="Choose a client"
                  options={
                    clientOptionData &&
                    clientOptionData.map((data) => {
                      return {
                        label: data.company_name,
                        _id: data._id,
                      };
                    })
                  }
                  defaultValue={value}
                  onChange={onChange}
                  invalid={errors.client}
                />
              )}
            />
            {errors.client && (
              <TextStyles.InValidFeedback className="mt-2">
                {errors.client.message}
              </TextStyles.InValidFeedback>
            )}
          </TextStyles.FontSize14px>
          <TextStyles.FontSize14px className="mb-3">
            <label htmlFor="client" className="mb-2">
              Select Currency
            </label>
            <Controller
              control={control}
              name="currency"
              render={({ field: { onChange, value } }) => (
                <SelectCurrency
                  placeholder="Select currency"
                  onChange={onChange}
                  defaultValue={value}
                />
              )}
            />
          </TextStyles.FontSize14px>

          <TextStyles.FontSize14px className="mb-2">
            <div htmlFor="project_start_date" className="mb-2">
              Start Date
            </div>

            <Controller
              name={"project_start_date"}
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <CustomDatePickerOne
                    onChange={onChange}
                    selected={value}
                    placeholder="Select start date"
                    allowClear={false}
                  />
                );
              }}
            />
          </TextStyles.FontSize14px>
          <TextStyles.FontSize14px className="">
            <div className="d-flex justify-content-between align-items-center">
              <div htmlFor="project_end_date">End Date</div>
              <div className="d-flex align-items-center">
                <TextStyles.FontSize14px
                  style={{ color: Colors.primary, fontWeight: 500 }}
                >
                  Ongoing
                </TextStyles.FontSize14px>
                <SwitchButton
                  defaultChecked={selectEndDate}
                  onChange={(event) => setSelectEndDate(event.target.checked)}
                />
              </div>
            </div>
            {selectEndDate ? (
              ""
            ) : (
              <Controller
                name={"project_end_date"}
                control={control}
                rules={{ validate: validateEndDate }}
                render={({ field: { onChange, value } }) => {
                  return (
                    <CustomDatePickerOne
                      onChange={onChange}
                      selected={value}
                      placeholder="Select end date"
                      allowClear={true}
                    />
                  );
                }}
              />
            )}
            {endDateErrorMessage && (
              <TextStyles.InValidFeedback className="mt-2">
                {endDateErrorMessage}
              </TextStyles.InValidFeedback>
            )}
          </TextStyles.FontSize14px>
        </Modal.Body>
        <Modal.Footer style={{ display: "inline-block" }}>
          <div className="d-flex gap-3 justify-content-between">
            <TextStyles.CancelButton onClick={handleClose}>
              Cancel
            </TextStyles.CancelButton>
            <TextStyles.Button disabled={isLoading}>
              {isLoading ? <LoaderSpin /> : "Save"}
            </TextStyles.Button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default PCEditProjectInfo;
